import React, { useEffect, useRef } from 'react';
import ContactFormCT from './ContactFormCT';

const Modal = ({ isOpen = false, onClose }) => {
  const modalRef = useRef(null);

  // Disable body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  // Handle Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  // Focus trap
  useEffect(() => {
    if (isOpen && modalRef.current) {
      const focusableElements = modalRef.current.querySelectorAll(
        'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]'
      );
      
      if (focusableElements.length > 0) {
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        
        firstElement.focus();

        const handleTab = (e) => {
          if (e.key === 'Tab') {
            if (e.shiftKey) {
              if (document.activeElement === firstElement) {
                e.preventDefault();
                lastElement.focus();
              }
            } else {
              if (document.activeElement === lastElement) {
                e.preventDefault();
                firstElement.focus();
              }
            }
          }
        };

        const currentModal = modalRef.current;
        currentModal.addEventListener('keydown', handleTab);
        return () => {
          currentModal.removeEventListener('keydown', handleTab);
        };
      }
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      <div 
        className="backdrop is-open" 
        onClick={onClose} 
        style={{ display: 'block' }}
      />
      <div
        className="modal is-open"
        id="modal"
        ref={modalRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modalTitle"
        aria-hidden="false"
        style={{ display: 'block' }}
      >
        <div className="form-card" style={{ boxValues: 'none', borderRadius: 'var(--r-lg)' }}>
          <div className="form-card__head" style={{ background: 'var(--navy)', position: 'relative' }}>
            <button className="modal-x" id="modalX" aria-label="Close" onClick={onClose}>
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M6 6l12 12M18 6 6 18" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
              </svg>
            </button>
            <h2 id="modalTitle" style={{ color: '#fff' }}>
              Book a free review
            </h2>
            <p style={{ color: 'var(--navy-100)' }}>
              Tell us how to reach you. A senior accountant calls you back within one business day.
            </p>
          </div>
          <div className="form-card__body">
            <ContactFormCT formId="modalForm" isModal={true} onCloseModal={onClose} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;
